import { createHashHistory } from 'history';
/**
 * Creating a Browser history
 * @exports Helpers__History-Creator
 */ 
export const history = createHashHistory();